import { Form } from '@packages/chakra-v3';
import type { ProductReviewFormType } from '../../schema';
import React from 'react';
import { Stack } from '@chakra-ui/react';

const ProductReviewForm = () => {
	return (
		<Stack gap={8}>
			<Form.ImageListUpload<ProductReviewFormType>
				aspectRatio={'square'}
				label={'Images'}
				maxFields={3}
				name={'images'}
			/>
			<Form.RatingInput<ProductReviewFormType>
				label={'Rating'}
				name={'rating'}
			/>
			<Form.TextareaInput<ProductReviewFormType>
				label={'Review'}
				name={'comment'}
			/>
		</Stack>
	);
};

export default ProductReviewForm;